import React from 'react';
import ViewStudent from './ViewStudent';
import '../../../CommonCSS/SocietyCSS.css'


const ViewStudentApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> View Student </h5>
          </div>
        </div>
        <ViewStudent/>
      </div>
    </div >
  );
};

export default ViewStudentApp;
